<section class="hero is-success is-small">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        <span class="icon-text">
          <span class="icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></span>
          <span data-proposition-heading></span>
        </span>
      </h1>
    </div>
  </div>
</section>

<section class="section container">
  <div class="box">
    <dl>
      <dt><strong>Name</strong></dt><dd><code data-proposition-name></code></dd>
      <dt><strong>Description</strong></dt><dd data-proposition-description></dd>
    </dl>
  </div>
</section>
